/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Inbox_Ws_Fresh_DoneInputs */

const en_inbox_ws_fresh_done = /** @type {(inputs: Inbox_Ws_Fresh_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} steps finished since you last looked`)
};

const id_inbox_ws_fresh_done = /** @type {(inputs: Inbox_Ws_Fresh_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} langkah selesai sejak terakhir kamu lihat`)
};

/**
* | output |
* | --- |
* | "{n} steps finished since you last looked" |
*
* @param {Inbox_Ws_Fresh_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_ws_fresh_done = /** @type {((inputs: Inbox_Ws_Fresh_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Ws_Fresh_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_ws_fresh_done(inputs)
	return en_inbox_ws_fresh_done(inputs)
});